var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("p", {
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("嵌套菜单")) + "1-2-1")]), _c("a-tag", {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      color: "skyblue"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("嵌套菜单")) + "1-2-1 ")])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };